import React, { useState } from "react";
import "../../css/zoomcontrols.css";

const ZoomControls = ({ children }) => {
  const [scale, setScale] = useState(1); // 初期スケール

  const handleZoomIn = () => {
    setScale((prevScale) => Math.min(prevScale + 0.1, 2)); // 最大2倍
  };

  const handleZoomOut = () => {
    setScale((prevScale) => Math.max(prevScale - 0.1, 0.5)); // 最小50%
  };

  return (
    <div style={{ transform: `scale(${scale})`, transformOrigin: "center" }}>
      <div>{children}</div> {/* スケール対象 */}
      <div className="zoom-controls">
        <button onClick={handleZoomIn}>＋</button>
        <button onClick={handleZoomOut}>－</button>
      </div>
    </div>
  );
};

export default ZoomControls;
